import React, {Component} from "react";
import {connect} from "react-redux";
import {translate} from "react-i18nify";
import {ReactSVG} from "react-svg";

import * as resources from "../../constants/resources";
import * as componentTypes from "../../constants/componentTypes";
import * as navigationActions from "../../actions/navigationActions";
import * as computerActions from "../../actions/computerActions";
import * as windowService from "../../services/windowService";

import imgClose from "../../resources/img/svgicons/close.svg";
import imgMaximizable from "../../resources/img/svgicons/maximizable.svg";
import imgMaximize from "../../resources/img/svgicons/maximize.svg";
import imgMinimize from "../../resources/img/svgicons/minimize.svg";

class FramePanel extends Component {
    constructor(props) {
        super(props);

        let maximized = windowService.getMaximized();

        this.state = {
            maximizeImg: maximized ? imgMaximize : imgMaximizable,
            maximized: maximized
        };
    }

    componentDidMount = () => {
        let mainWindow = windowService.getCurrentWindow();

        if (mainWindow !== null) {
            mainWindow.on("maximize", () => {
                this.setState({
                    maximizeImg: imgMaximize,
                    maximized: true
                });
            });
            mainWindow.on("unmaximize", () => {
                this.setState({
                    maximizeImg: imgMaximizable,
                    maximized: false
                });
            });
        }
    };

    componentWillUnmount = () => {
        windowService.removeAllWindowListeners();
    };

    handleCloseWindowClick = () => {
        if (this.props.lockComputer) {
            this.props.dispatchShutdownComputerAction(this.props.softwareName);
        } else {
            this.props.dispatchCloseRedlikeAction(this.props.softwareName);
        }
    };

    handleMaximizeWindowClick = () => {
        windowService.maximizeWindow();
    };

    handleMinimizeWindowClick = () => {
        windowService.minimizeWindow();
    };

    getMinimizeIcon = () => {
        if (this.props.kiosk || windowService.isBrowser()) {
            return "";
        }

        return (
            <div className="aplication-btn pull-right">
                <button className="btn btn-xs btn-close">
                    <ReactSVG alt="minimize" src={imgMinimize} onClick={this.handleMinimizeWindowClick} />
                </button>
            </div>
        );
    };

    getMaximizeIcon = () => {
        if (this.props.kiosk || windowService.isBrowser()) {
            return "";
        }

        return (
            <div className="aplication-btn pull-right">
                <button className="btn btn-xs btn-close btn-maximize">
                    <ReactSVG
                        className={this.state.maximized ? "img-maximize" : ""}
                        alt="maximize"
                        src={this.state.maximizeImg}
                        onClick={this.handleMaximizeWindowClick}
                    />
                </button>
            </div>
        );
    };

    getCloseIcon = () => {
        if (windowService.isBrowser()) {
            return "";
        }

        if (this.props.loggedUser !== null && this.props.loggedUser.canNotRead(resources.FUNCTION_CLOSE_REDLIKE)) {
            return "";
        }

        return (
            <div className="aplication-btn pull-right">
                <button className="btn btn-xs btn-close">
                    <ReactSVG alt="close" src={imgClose} onClick={this.handleCloseWindowClick} />
                </button>
            </div>
        );
    };

    render() {
        if (this.props.gammaSoftware) {
            return (
                <div className="container-fluid pull-right aplication-btn-group" style={{WebkitAppRegion: "no-drag"}} />
            );
        }

        if (this.props.lightSoftware && this.props.light) {
            return (
                <div
                    className="container-fluid frame-panel pull-left aplication-btn-group"
                    style={{WebkitAppRegion: "no-drag"}}
                >
                    {this.getCloseIcon()}
                    {this.getMaximizeIcon()}
                    {this.getMinimizeIcon()}
                </div>
            );
        }

        return (
            <div className="container-fluid pull-right aplication-btn-group" style={{WebkitAppRegion: "no-drag"}}>
                {this.getCloseIcon()}
                {this.getMaximizeIcon()}
                {this.getMinimizeIcon()}
            </div>
        );
    }
}
const mapStoreToProps = (store) => {
    return {
        loggedUser: store.login.loggedUser,
        gammaSoftware: store.module.gammaSoftware,
        lightSoftware: store.module.redlikeLightSoftware,
        kiosk: store.settings.kiosk,
        lockComputer: store.settings.lockComputer,
        softwareName: store.settings.softwareName
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchCloseRedlikeAction: (softwareName) => {
            dispatch(
                navigationActions.deleteItemConfirmation(
                    componentTypes.MODAL_NO_TAB,
                    navigationActions.closeRedlikeWindow(),
                    translate("dialog.reallyCloseRedlike", {name: softwareName})
                )
            );
        },
        dispatchShutdownComputerAction: (softwareName) => {
            dispatch(
                navigationActions.openConfirmationModal(
                    componentTypes.MODAL_NO_TAB,
                    computerActions.shutdownComputer(),
                    translate("dialog.reallyShutdownPc", {name: softwareName})
                )
            );
        }
    };
};

export default FramePanel = connect(mapStoreToProps, mapDispatchToProps)(FramePanel);
